import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "../sidebar/Sidebar";
import Topbar from "../topbar/Topbar";

export function AppShell({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname, location.search]);

  const toggleSidebar = () => {
    setSidebarOpen((v) => !v);
    setSidebarCollapsed((v) => !v);
  };

  return (
    <div className={`app-shell${sidebarCollapsed ? " sidebar-collapsed" : ""}`} id="app">
      <Sidebar open={sidebarOpen} collapsed={sidebarCollapsed} />
      <main className="main">
        <Topbar onMenuToggle={toggleSidebar} />
        <section className="view" id="view" data-testid="main-view">
          {children}
        </section>
      </main>
    </div>
  );
}

export default AppShell;
